export default __webpack_public_path__ + "static/media/Shapes_22.c391efab.png";